export enum ModalType {
  Idle,
  Add,
  Edit,
  Delete,
}
